import React from 'react';

class CustomTooltip extends React.Component {
  render() {
    let payload;
    if (this.props.payload && this.props.payload[0]) {
      payload = this.props.payload[0];
    }
    if (!payload) {
      return null;
    }

    const tooltipStyle = {
      toolTipContent: {
        color: 'white'
      },
      toolTip: {
        opacity: 0.7,
        borderRadius: '2px',
        backgroundColor: '#485465',
        padding: 10
      }
    };
    if (this.props.double) {
      const { first_key, second_key } = this.props;
      return (
        <div style={tooltipStyle.toolTip}>
          <div style={tooltipStyle.toolTipContent}>
            {payload.payload.name} <br />
            {first_key ? `${first_key}:` : ''}{' '}
            {payload.payload.first ? payload.payload.first : ''} <br />
            {second_key ? `${second_key}:` : ''}{' '}
            {payload.payload.second ? payload.payload.second : ''}
          </div>
        </div>
      );
    } else {
      return (
        <div style={tooltipStyle.toolTip}>
          <div style={tooltipStyle.toolTipContent}>
            {payload.payload.name} {payload.payload.value}
          </div>
        </div>
      );
    }
  }
}

export default CustomTooltip;



// WEBPACK FOOTER //
// ./src/components/CustomTooltip/index.js